// sync with server/src/utils/activities.ts
type CalculateActivityValueParams = {
  units: number;
  committingPointsValue?: number;
  committingMarketValue?: number;
  committingImpactProxyValue?: number;
};
// number_of_units_committed*committing_points_value
// number_of_units_reported_SV1Q1*reporting_market_value

const equationParamsToVariablesMap: Record<string, keyof CalculateActivityValueParams> = {
  committing_points_value: 'committingPointsValue',
  number_of_units_committed: 'units',
  committing_market_value: 'committingMarketValue',
  committing_impact_proxy_value: 'committingImpactProxyValue',
};

export const calculateActivityValue = (
  calculationRule: string = '',
  data: CalculateActivityValueParams
) => {
  const [firstParam, secondParam] = calculationRule.split('*');
  const firstParamKey = equationParamsToVariablesMap[firstParam];
  const secondParamKey = equationParamsToVariablesMap[secondParam];

  if (!firstParamKey) {
    console.error(`Invalid calculation rule: ${firstParam}`);
    return 0;
  }

  if (!secondParamKey) {
    console.error(`Invalid calculation rule: ${secondParam}`);
    return 0;
  }

  const firstParamValue = data[firstParamKey];
  const secondParamValue = data[secondParamKey];

  if (!firstParamValue || !secondParamValue) {
    return 0;
  }

  const result = firstParamValue * secondParamValue;
  return result;
};

export const activitiesSortByCodeFn = (a: any, b: any) => {
  // example of code is SV2a, sv2b, sv10a ...etc
  // extract the activity number
  const aNumber = a.code.match(/SV(\d+)/)?.[1];
  const bNumber = b.code.match(/SV(\d+)/)?.[1];
  // extract the activity suffix
  const aSuffix = a.code.replace(/^SV\d+/, '').match(/([a-zA-Z]+)/)?.[1];
  const bSuffix = b.code.replace(/^SV\d+/, '').match(/([a-zA-Z]+)/)?.[1];

  let result = 0;

  if (parseInt(aNumber) > parseInt(bNumber)) {
    result = 1;
  } else if (parseInt(aNumber) < parseInt(bNumber)) {
    result = -1;
  } else {
    result = aSuffix.localeCompare(bSuffix);
  }

  return result;
};
